"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manual_end = void 0;
var api_1 = require("../../../api");
var manual_end = function (req) {
    return (0, api_1.apiPost)({
        endpoint: "v3/auction/manual_end",
        // data: formData,
        data: req,
    });
};
exports.manual_end = manual_end;
